import { render, staticRenderFns } from "./Premier.vue?vue&type=template&id=4653ad20&"
import script from "./Premier.vue?vue&type=script&lang=js&"
export * from "./Premier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports